(() => {
  const data = document.getElementById('rsp-review-translations');
  if (!data || !document.documentElement.lang.toLowerCase().startsWith('es')) return;
  const labels = JSON.parse(data.textContent);
  const containers = '#judgeme_product_reviews, .jdgm-carousel-title-and-link, .jdgm-form-wrapper, .jdgm-review-widget-modal, .jm-modal, .jm-dialog, [data-widget-container="review-form"], [data-widget-container="review-widget"]';
  const excluded = '.jdgm-rev, .jdgm-carousel-item, .jm-review-card, .jm-review-content, .jm-review-item, .jm-review-body, script, style';
  const translate = text => {
    const normalized = text.trim().replace(/\s+/g, ' ');
    let value = labels[normalized];
    if (!value) {
      let match = normalized.match(/^from ([\d,.]+) reviews?$/i);
      if (match) value = match[1] + ' reseñas';
      match = normalized.match(/^Based on ([\d,.]+) reviews?$/i);
      if (match) value = 'Basado en ' + match[1] + ' reseñas';
      match = normalized.match(/^([\d,.]+) reviews?$/i);
      if (match) value = match[1] + ' reseñas';
      match = normalized.match(/^([\d.]+) stars?$/i);
      if (match) value = match[1] + (match[1] === '1' ? ' estrella' : ' estrellas');
    }
    return value ? text.replace(text.trim(), value) : text;
  };
  const update = () => {
    document.querySelectorAll(containers).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!node.parentElement || node.parentElement.closest(excluded + ', textarea')) continue;
        const value = translate(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      [root, ...root.querySelectorAll('[placeholder], [aria-label], [title], input[type="submit"], input[type="button"]')].forEach(el => {
        if (el.closest(excluded)) return;
        for (const attribute of ['placeholder', 'aria-label', 'title']) {
          const value = el.getAttribute(attribute);
          if (value) {
            const translated = translate(value);
            if (translated !== value) el.setAttribute(attribute, translated);
          }
        }
        if (el.matches('input[type="submit"], input[type="button"]')) {
          const value = translate(el.value);
          if (value !== el.value) el.value = value;
        }
      });
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      observer.disconnect();
      update();
      observer.observe(document.body, {childList:true, subtree:true, characterData:true});
    });
  });
  observer.observe(document.body, {childList:true, subtree:true, characterData:true});
  update();
})();